<mat-card>
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>Two Factor Authentication</mat-card-title>
      <mat-card-subtitle>Username: {{credentialUsername}}</mat-card-subtitle>
    </mat-card-title-group>
  </mat-card-header>

  <mat-card-content>
    <p class="box box-warn">
      Your organisation has enforced 2-step verification on your account. You cannot turn it off,
      but you can add or change your second steps.
    </p>

    @for (mfa of mfas; track mfa) {
      <div class="list-item">
        <div>
          <p>{{ readableName[mfa.type] }}</p>
          <div class="text-gray">Registered on {{ mfa.createdAt | date:'medium' }}</div>
        </div>
        <div>
          <ul class="list-inline list-unstyled">
            <li>
              @if (canReplaceMFA(mfa)) {
                <button mat-flat-button color="primary"
                  (click)="createMFA(mfa.type)"
                  [attr.aria-label]="'Replace ' + readableName[mfa.type]">
                  Replace
                </button>
              }
            </li>
            <li>
              @if (canDelete()) {
                <button mat-flat-button color="warn"
                  (click)="deleteMFA(mfa.id)"
                  [attr.aria-label]="'Remove ' + readableName[mfa.type]">
                  Remove
                </button>
              }
            </li>
          </ul>
        </div>
      </div>
    }
  </mat-card-content>
  <mat-card-actions>
    @if (canAdd()) {
      <button mat-flat-button color="primary" (click)="createMFA()">
        <mat-icon>add</mat-icon>
        Setup two factor authentication
      </button>
    }
    <button mat-stroked-button color="warn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </mat-card-actions>

</mat-card>
